import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AssignCdsCC } from 'src/app/models/assign.model';
import * as globals from '../../globals';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { AssignmentsService } from 'src/app/services/assignments.service';
import { firstValueFrom } from 'rxjs';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-assignments-list',
  templateUrl: './assignments-list.component.html',
  styleUrls: ['./assignments-list.component.scss']
})
export class AssignmentsListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private snackBar: MatSnackBar,
    private assignmentService: AssignmentsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.getAccountsCdsAT();
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
  }

  private async assignCdsCC(assign: AssignCdsCC) {
    try {
      this.loadingSpinner(true);
      const assignData = await firstValueFrom(this.assignmentService.getAssignment(Number(assign.account_id)));
      assignData != null ? this.sidenavassign.open() : this.sidenavassign.close();
      this.assignment = assignData;
      this.loadingSpinner(false);
    }
    catch {
      this.sidenavassign.close();
      this.loadingSpinner(false);
    }
  }

  private getAccountsCdsAT() {
    try {
      this.loadingSpinner(true);
      this.assignmentService.getAssignments().subscribe({
        next: (data) => {
          this.dataSource = new MatTableDataSource(data);
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch {}
  }

  assignedClient = (response) => this.refreshData();

  cancelledAssign = (response) => this.refreshData();

  private refreshData = () => {
    this.assignment = new AssignCdsCC();
    this.getAccountsCdsAT();
  };

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  private loadingSpinner = (value: boolean) => this.isLoading = value;

  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 5000 });

  isContributor: boolean;
  isLoading: boolean;
  assignment: AssignCdsCC;
  dataSource = new MatTableDataSource<AssignCdsCC>();
  secretVisibility = new Map<number, boolean>();
  displayedColumns: string[] = globals.assignments_columns;

  @ViewChild('sidenavassign') sidenavassign: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
